import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import { B2B_SITE_ORIGIN } from "@danishagro/shared/src/constants/urlRoot.constants";
import { useAppData } from "@danishagro/shared/src/contexts/appData.context";
import { useSiteHeader } from "@danishagro/shared/src/contexts/siteHeader.context";
import { getRelativeRootOnLocalhost } from "@danishagro/shared/src/helpers/getRelativeUrlOnLocalhost.helper";

export const useFarmInTimeButton = () => {
    const { cvrAndCustomerNumbers, customerNumber } = useAppData();
    const { pathname } = useLocation();

    const { showMiniCart, showAccountPicker } = useSiteHeader();

    // Mappers

    const hasOpenMenu = useMemo(
        (): boolean => showMiniCart || showAccountPicker,
        [showMiniCart, showAccountPicker]
    );

    const isFarmInTimePage = useMemo(
        (): boolean => pathname.indexOf("bestillingsliste") >= 0,
        [pathname]
    );

    return {
        showFarmInTime: cvrAndCustomerNumbers && customerNumber,
        farmInTimeLink: `${getRelativeRootOnLocalhost(B2B_SITE_ORIGIN)}/bestillingsliste`,
        isFarmInTimeMenuActive: isFarmInTimePage && !hasOpenMenu,
    };
};
